// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"49909182","455":"f2d3cdb0","977":"5140821e"}[chunkId] + ".chunk.js";
};